export function ChevronRight (): JSX.Element {
  return <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
    <path d="M1 1L9 9L1 17" stroke="#514F53" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}
